module.exports = __webpack_public_path__ + "static/media/discount-coupon@3x.01e2b857.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroom/discount-coupon@3x.png
// module id = 2011
// module chunks = 6